var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-banner"},[(
      _vm.extras.banner &&
      _vm.extras.banner.display == 1 &&
      _vm.extras.banner.colorOrBg == 'color'
    )?_c('div',{staticClass:"g-banner-div",style:({
      backgroundColor:
        _vm.extras && _vm.extras.banner && _vm.extras.banner.color
          ? _vm.extras.banner.color
          : _vm.defaultColor,
    })}):_vm._e(),(
      _vm.extras.banner &&
      _vm.extras.banner.display == 1 &&
      _vm.extras.banner.colorOrBg == 'src' &&
      _vm.extras.kvlink &&
      _vm.extras.kvlink.display == 1
    )?_c('a',{attrs:{"href":_vm.extras.kvlink.model}},[(
        _vm.extras.banner &&
        _vm.extras.banner.display == 1 &&
        _vm.extras.banner.colorOrBg == 'src'
      )?_c('img',{staticClass:"g-banner-new",attrs:{"src":_vm.extras.banner && _vm.extras.banner.src
          ? _vm.extras.banner.src
          : _vm.imgUrlObj.pc.kv}}):_vm._e()]):_vm._e(),(
      _vm.extras.banner &&
      _vm.extras.banner.display == 1 &&
      _vm.extras.banner.colorOrBg == 'src' &&
      (_vm.extras.kvlink === undefined || _vm.extras.kvlink.display == 0)
    )?_c('img',{staticClass:"g-banner-new",attrs:{"src":_vm.extras.banner && _vm.extras.banner.src ? _vm.extras.banner.src : _vm.imgUrlObj.pc.kv}}):_vm._e(),_c('div',{staticClass:"g-seminar-content-new"},[_c('div',{staticClass:"seminar-info"},[_c('div',{staticClass:"seminar-title",style:({
          display:
            _vm.extras.titlefont && _vm.extras.titlefont.display == 1
              ? 'block'
              : 'none',
          color: _vm.extras.titlefont && _vm.extras.titlefont.color,
        }),domProps:{"innerHTML":_vm._s(_vm.seminarInfo.title)}}),(_vm.seminarInfo.startTime)?_c('div',{staticClass:"seminar-time"},[_c('span',{style:({
            display:
              _vm.extras.meetingTime && _vm.extras.meetingTime.display == 1
                ? 'block'
                : 'none',
            color: _vm.extras.meetingTime && _vm.extras.meetingTime.color,
          })},[_vm._v(_vm._s(_vm.handleTimeStamps(_vm.seminarInfo.startTime, _vm.seminarInfo.endTime)))]),(_vm.seminarInfo.address)?_c('div',{style:({
            display:
              _vm.extras.meetingAddress && _vm.extras.meetingAddress.display == 1
                ? 'block'
                : 'none',
            color: _vm.extras.meetingAddress && _vm.extras.meetingAddress.color,
          })},[_vm._v(" "+_vm._s(_vm.seminarInfo.address)+" ")]):_vm._e()]):_vm._e()]),_c('div',{staticClass:"seminar-remainder",style:({
        display:
          _vm.extras.meetingCountDown && _vm.extras.meetingCountDown.display == 1
            ? 'block'
            : 'none',
        color: _vm.extras.meetingCountDown && _vm.extras.meetingCountDown.color,
      })},[(_vm.seminarStatus === 3)?_c('span',[_vm._v("进行中")]):_vm._e(),(_vm.seminarStatus === 4)?_c('span',[_vm._v("已结束")]):_vm._e(),(_vm.seminarStatus === 1)?_c('span',[_vm._v("距离会议开始"),_c('span',{staticClass:"seminar-remainder-num",style:({
            color:
              _vm.extras.meetingCountDownNum && _vm.extras.meetingCountDownNum.color,
          })},[_vm._v(_vm._s(_vm.remainder.days))]),_vm._v("天"),_c('span',{staticClass:"seminar-remainder-num",style:({
            color:
              _vm.extras.meetingCountDownNum && _vm.extras.meetingCountDownNum.color,
          })},[_vm._v(_vm._s(_vm.remainder.hours))]),_vm._v("时"),_c('span',{staticClass:"seminar-remainder-num",style:({
            color:
              _vm.extras.meetingCountDownNum && _vm.extras.meetingCountDownNum.color,
          })},[_vm._v(_vm._s(_vm.remainder.minutes))]),_vm._v("分")]):_vm._e()]),(!_vm.isFrozen && _vm.seminarStatus !== 4)?_c('div',{staticClass:"seminar-btn"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSetting == 1 && _vm.extras.noSignUp.display == 1),expression:"isSetting == 1 && extras.noSignUp.display == 1"}],staticClass:"btn",class:_vm.isSetting == 1 ? 'cursor-default' : '',style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        })},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
          _vm.isSetting !== 1 &&
          _vm.extras.noSignUp.display == 1 &&
          _vm.memberInfo.signUpStatus == 0 &&
          !_vm.isLogin &&
          _vm.seminarInfo.isOpenMember != 0 &&
          _vm.signUpUrl
        ),expression:"\n          isSetting !== 1 &&\n          extras.noSignUp.display == 1 &&\n          memberInfo.signUpStatus == 0 &&\n          !isLogin &&\n          seminarInfo.isOpenMember != 0 &&\n          signUpUrl\n        "}],staticClass:"btn",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('newLogin')}}},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]),(
          _vm.isSetting !== 1 &&
          _vm.extras.noSignUp.display == 1 &&
          _vm.memberInfo.signUpStatus == 0 &&
          (_vm.isLogin || _vm.seminarInfo.isOpenMember == 0) &&
          _vm.signUpUrl
        )?_c('div',{staticClass:"btn",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]):_vm._e(),(
          _vm.isSetting !== 1 &&
          _vm.extras.checkPending.display == 1 &&
          _vm.memberInfo.signUpStatus == 1
        )?_c('div',{staticClass:"btn audit",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.checkPending.model || "审核中...")+" ")]):_vm._e(),(
          _vm.isSetting !== 1 &&
          _vm.extras.approve.display == 1 &&
          (_vm.memberInfo.signUpStatus == 2 || _vm.memberInfo.signUpStatus == 3)
        )?_c('div',{staticClass:"btn registered",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.approve.model || "报名成功")+" ")]):_vm._e(),(
          _vm.isSetting !== 1 &&
          _vm.extras.reject.display == 1 &&
          _vm.memberInfo.signUpStatus == 4
        )?_c('div',{staticClass:"btn refuse",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.reject.model || "拒绝报名")+" ")]):_vm._e(),(_vm.seminarStatus === 2)?_c('div',{staticClass:"btn registered"},[_vm._v("会议已结束")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }